import { Box, Divider, Typography } from "@mui/material";
import { format } from "date-fns";

import ViewerIconButton from "../../../../components/ViewerIconButton";

interface DocumentListProp {
  label: string
  createdAt: string
  status: string
  id: string
  value?: string
}

function DocumentList({
  label,
  createdAt,
  status,
  id,
  value,
}: DocumentListProp): JSX.Element {
  const props = value ? JSON.parse(value) : {};
  return (
    <Box
      key={id}
      onClick={() => {
        
      }}
      sx={{
        display: "flex",
        flexDirection: "column",
        cursor: status === "ACTIVE" ? "pointer" : "default",
        padding: 0,
        gap: 1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          marginTop: "12px",
          marginBottom: "4px",
        }}
      >
        <Typography fontSize={14} fontWeight={500} variant="subtitle2">
          {label}
        </Typography>
        <Box style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <Typography
            color="white.light"
            fontSize={12}
            fontWeight={400}
            variant="body2"
          >
            Processo iniciado
          </Typography>
          <ViewerIconButton
            documentId={props.fileUid}
          />
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography fontSize={12} fontWeight={400} variant="body2">
          {format(new Date(createdAt), "dd/MM/yyyy")}
        </Typography>
        <Typography
          color="white.light"
          fontSize={12}
          fontWeight={400}
          variant="body2"
        >
          {status}
        </Typography>
      </Box>
      <Divider />
    </Box>
  );
}

export default DocumentList